import React, { useEffect, useState } from 'react';
import cls from '@utils/css-select'
import styles from './styles.scss'
import { ListItem, getReferralData } from '@services/invite-friends';
import { useTranslation } from 'hooks/use-translation';
import { Modal } from 'components/dialogs';

const cx = cls(styles)
const avatarDefault = 'https://web-data.zmlearn.com/image/5ptYtkxV8BHmJDkyXenyYk/avatar_default_mini.png'
export type ReferralData = {
	// total?: number;
	// auditionNum?: number;
	attendance?: number;
	paidNum?: number;
	rewardSum?: number;
}

const statusDict: { [propName: number]: string } = {
	1: 'Paid',
	2: 'Auditioned',
	3: 'Registered'
}


function ReferralHistory(props: Record<string, any>) {
	const { transData: modal } = props
	const [listData, setListData] = useState<ListItem[]>([])
	const [referralData, setReferralData] = useState<ReferralData>({
		attendance: 0,
		paidNum: 0,
		rewardSum: 0
	})

	useEffect(() => {
		getReferralData({ pageNo: 1, pageSize: 500 })
			.then((res: any) => {
				const { auditionNum, paidNum, rewardSum } = res.data
				setReferralData({
					attendance: auditionNum || 0, // 转介绍新生的出席试听课的人数
					paidNum: paidNum || 0, //  转介绍新生付费的人数
					rewardSum: rewardSum || 0 // 转介绍账户余额
				})
				setListData(res.data?.records || [])
			})
	}, [])

	return (
		<div className={cx('dialog-history-wrap')}>
			<ul className={cx('count')}>
				<li>
					<span className={cx('num', { 'zero': !referralData.attendance })}>{referralData.attendance}</span>
					<span className={cx('num-title')}>{modal.span1}</span>
				</li>
				<li>
					<span className={cx('num', { 'zero': !referralData.paidNum })}>{referralData.paidNum}</span>
					<span className={cx('num-title')}>{modal.span2}</span>
				</li>
				<li>
					<span className={cx('num', { 'zero': !referralData.rewardSum })}>{`$${referralData.rewardSum}`}</span>
					<span className={cx('num-title')}>{modal.span3}</span>
				</li>
			</ul>
			<ul className={cx('detail-list', 'scroll-bar')}>
				{!listData.length ?
					<li className={cx('no-data')}>{modal.li}</li> :
					listData.map(itemData => (
						<li key={itemData.userId}>
							<span className={cx('item-head-pic')}>
								<img src={itemData.userInfo.avatar || avatarDefault} alt={itemData.userInfo.firstName} />
							</span>
							<p className={cx('name')}>{itemData.userInfo.firstName}</p>
							<span className={cx('status')}>{statusDict[itemData.status] || ''}</span>
						</li>
					))
				}
			</ul>
		</div>
	)
}

export default ReferralHistory
